var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const automaticUnitPricing = () => {
    let unitPriceCalculation;
    const productBlock = document.querySelector('[data-product-blocks]');
    if (productBlock) {
        unitPriceCalculation = productBlock.getAttribute('data-unit-price-calculation');
    }
    if (unitPriceCalculation == 'automatic') {
        const radioGroups = document.querySelectorAll('fieldset:not([name="Quantity"])');
        const quantityGroup = document.querySelector('fieldset[name="Quantity"]');
        const quantityButtons = quantityGroup === null || quantityGroup === void 0 ? void 0 : quantityGroup.querySelectorAll('input[type="radio"]');
        const variantSelects = productBlock.querySelectorAll('select');
        const quantityInputSelectElement = document.querySelector('.variant-input-wrap[data-index="option1"] select');
        const updateUnitPrice = (quantity) => {
            // This is a repeat of the logic from heapsgood.js
            const productPriceSpanElement = document.querySelector('.product__price');
            const unitPriceSpanElement = document.querySelector('.unit-price');
            let priceAsMoneyString = productPriceSpanElement.innerHTML;
            let priceAsString_noOpeningSpan = priceAsMoneyString.replace('<span aria-hidden="true">', '');
            let priceAsString_noClosingSpan = priceAsString_noOpeningSpan.replace('</span>', '');
            let priceAsString = priceAsString_noClosingSpan.replace('$', '');
            priceAsString = priceAsString.replace(',', '');
            let priceAsFloat = parseFloat(priceAsString);
            let units = quantity;
            units = parseInt(units);
            let unitPrice = (priceAsFloat / units).toFixed(2);
            unitPriceSpanElement.innerHTML = `$${unitPrice}`;
        };
        // Page Load
        if (quantityGroup) {
            const setUnitPrice_pageLoad = () => {
                const activeQty = quantityGroup === null || quantityGroup === void 0 ? void 0 : quantityGroup.querySelector(':checked');
                const activeQty_value = activeQty === null || activeQty === void 0 ? void 0 : activeQty.value;
                updateUnitPrice(activeQty_value);
            };
            setUnitPrice_pageLoad();
        }
        if (variantSelects && quantityInputSelectElement) {
            const setUnitPrice_pageLoad = () => {
                const activeQty_value = quantityInputSelectElement.value;
                updateUnitPrice(activeQty_value);
            };
            setUnitPrice_pageLoad();
        }
        // User Selects New Quantity
        if (quantityGroup) {
            quantityButtons.forEach((button) => {
                button.addEventListener('click', function () {
                    const quantity = button.value;
                    setTimeout(() => {
                        updateUnitPrice(quantity);
                    }, 10);
                });
            });
        }
        // User Updates Price based on another Fieldset (Radio Button)
        if (radioGroups && quantityGroup) {
            radioGroups.forEach((group) => {
                const buttons = group.querySelectorAll('input[type="radio"]');
                buttons.forEach((button) => {
                    button.addEventListener('click', function () {
                        setTimeout(() => {
                            const activeQty = quantityGroup.querySelector(':checked');
                            const activeQty_value = activeQty.value;
                            updateUnitPrice(activeQty_value);
                        }, 10);
                    });
                });
            });
        }
        // User updates selects
        if (variantSelects && quantityInputSelectElement) {
            variantSelects.forEach((select) => {
                select.addEventListener('change', function () {
                    const quantityInputSelectElementValue = quantityInputSelectElement.value;
                    setTimeout(() => {
                        updateUnitPrice(quantityInputSelectElementValue);
                    }, 10);
                });
            });
        }
    }
    else if (unitPriceCalculation == 'manual') {
        const qtyContainer = document.querySelector('[data-custom-quantity]');
        const customUnitQtyString = qtyContainer.getAttribute('data-custom-variant-quantities');
        const customUnitQtyObj = JSON.parse(customUnitQtyString);
        const variantInput = document.querySelectorAll('[data-variant-input]');
        let currentVariant;
        let currentVariantQty;
        const getCurrentVariantOnLoad = () => {
            const selectorContainer = document.querySelector('[data-product-select]');
            const variantOnLoad = selectorContainer.options[selectorContainer.selectedIndex].value;
            currentVariant = variantOnLoad;
            currentVariantQty = getCurrentVariantQty(variantOnLoad);
            updateCustomUnitPrice();
        };
        const getCurrentVariantQty = (variantID) => {
            for (const [key, value] of Object.entries(customUnitQtyObj)) {
                if (key == variantID) {
                    currentVariantQty = value;
                    return currentVariantQty;
                }
            }
        };
        const getUpdatedVariant = () => {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const variant = urlParams.get('variant');
                    currentVariant = variant;
                    currentVariantQty = getCurrentVariantQty(variant);
                    resolve();
                }, 150);
            });
        };
        const updateCustomUnitPrice = () => {
            const productPriceSpanElement = document.querySelector('.product__price');
            const unitPriceSpanElement = document.querySelector('.unit-price');
            let priceAsMoneyString = productPriceSpanElement.innerHTML;
            let priceAsString_noOpeningSpan = priceAsMoneyString.replace('<span aria-hidden="true">', '');
            let priceAsString_noClosingSpan = priceAsString_noOpeningSpan.replace('</span>', '');
            let priceAsString = priceAsString_noClosingSpan.replace('$', '');
            priceAsString = priceAsString.replace(',', '');
            let priceAsFloat = parseFloat(priceAsString);
            const unitPriceSpan = document.querySelector('.unit-price-span');
            if (currentVariantQty === null) {
                unitPriceSpan.classList.add('unit-price-span--hide');
            }
            else {
                unitPriceSpan.classList.remove('unit-price-span--hide');
                let customUnitPrice = (priceAsFloat / Number(currentVariantQty)).toFixed(2);
                unitPriceSpanElement.innerHTML = `$${customUnitPrice}`;
            }
        };
        const updateVariantInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            yield getUpdatedVariant();
            updateCustomUnitPrice();
        });
        getCurrentVariantOnLoad();
        variantInput.forEach((input) => {
            input.addEventListener('change', () => {
                updateVariantInfo();
            });
        });
    }
};
export default automaticUnitPricing;
